
import { useStore } from "@/store";
import { computed, defineComponent, ref } from "vue";
import { PlayerActionTypes } from "@/store/player/action-types";
import { Equipment } from "@/const/equips/equipmentType";
import { equipTypes, equipTypesNames } from "@/const/equips/equipConst";

const store = useStore();
export default defineComponent({
  name: "EquipPack",
  setup() {
    const wearableEquips = computed(() => {
      return store.state.userWearableEquipments;
    });
    const handleCast = (row: Equipment) => {
      store.dispatch(PlayerActionTypes.PLAYER_CAST_EQUIP, row);
    };
    // 左侧装备 防具
    const leftEquip = ref([equipTypes.lorica]);
    // 右侧装备 武器和首饰
    const rightEquip = ref([equipTypes.weapon, equipTypes.necklace]);
    return {
      wearableEquips,
      handleCast,
      leftEquip,
      rightEquip,
      equipTypesNames
    };
  }
});
